<template>
  <div class="">
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover"
                    :href="route('influencers')"
      >
        Influencers
      </inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span>
      {{ form.influencer_code }}
    </h1>
    <trashed-message v-if="influencer.deleted_at" class="mb-6" @restore="restore">
      Dieses Influencer wurde gelöscht.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 ">
          Privatkredit: {{ influencerLink() }}
          <button
            class="ml-2 btn-green-small" tabindex="-1"
            type="button"
            @click="copyInfluencerLink()"
          >
            Kopieren
          </button>
        </div>
        <div class="p-8 -mr-6 -mb-8 ">
          Immobilienkredit: {{ influencerPropertyLink() }}
          <button
            class="ml-2 btn-green-small" tabindex="-1"
            type="button"
            @click="copyInfluencerPropertyLink()"
          >
            Kopieren
          </button>
        </div>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.first_name"
            :error="form.errors.first_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Name"
          />
          <text-input
            v-model="form.last_name"
            :error="form.errors.last_name"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nachname"
          />
          <text-input
            v-model="form.email"
            :error="form.errors.email"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Email-Adresse"
          />
          <text-input
            v-model="form.phone"
            :error="form.errors.phone"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Telefonnummer"
          />
          <text-input
            v-model="form.address"
            :error="form.errors.address"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Adresse"
          />
          <text-input
            v-model="form.zip_code"
            :error="form.errors.zip_code"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="PLZ"
          />
          <text-input
            v-model="form.city"
            :error="form.errors.city"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Ort"
          />
          <text-input
            v-model="form.country"
            :error="form.errors.country"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Land"
          />
          <div>
            <quill-editor
              ref="myQuillEditor"
              v-model="form.note"
              :error="form.errors.note"
              class="pr-6 pb-8 mb-8 w-full lg:w-full"
              label="Inhalt"
            />
          </div>
          <div class="w-full p2-6 pb-2">
            <table class="py-2 w-full md:w-1/2">
              <tr>
                <td>
                  Anzahl der Empfehlungen: {{ countAllClients() }}
                </td>
                <td class="text-right">
                  <inertia-link
                    class="ml-5 btn-green-small"
                    :href="route('clients', {search: form.influencer_code})"
                  >
                    Öffne
                  </inertia-link>
                </td>
              </tr>
            </table>
          </div>
          <div class="w-full pt-2 pb-6">
            <table class="w-full md:w-1/2">
              <tr v-for="item in clientStatusesCount" :key="item.status"
                  class="w-full border-b border-gray-100"
              >
                <td class="py-1">{{ statuses[item.status] }}</td>
                <td class="py-1 text-right">
                  <inertia-link :href="route('clients', {search: form.influencer_code, status: item.status})">
                    {{ item.count }}
                  </inertia-link>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!influencer.deleted_at" class="text-red-600 hover:underline" tabindex="-1"
                  type="button"
                  @click="destroy"
          >
            Löschen
          </button>
          <button v-if="influencer.deleted_at" class="text-green-600 hover:underline" tabindex="-1"
                  type="button"
                  @click="restore"
          >
            Wiederherstellen
          </button>
          <loading-button :loading="form.processing" class="btn-green ml-auto" type="submit">
            Aktualisieren
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '@/Shared/TrashedMessage'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import statuses from '../Clients/statuses'

export default {
  components: {
    quillEditor,
    LoadingButton,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    influencer: Object,
    clientStatusesCount: Array,
    tinyMceApiKey: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        'first_name': this.influencer.first_name,
        'last_name': this.influencer.last_name,
        'email': this.influencer.email,
        'phone': this.influencer.phone,
        'address': this.influencer.address,
        'zip_code': this.influencer.zip_code,
        'city': this.influencer.city,
        'country': this.influencer.country,
        'note': this.influencer.note,
        'influencer_code': this.influencer.influencer_code,
        'number_of_referrals': this.influencer.number_of_referrals,
      }),
    }
  },
  computed: {
    statuses() {
      return statuses
    },
  },
  metaInfo() {
    return {
      title: `${this.influencer.influencer_code}`,
    }
  },
  remember: 'form',
  methods: {
    countAllClients() {
      return this.clientStatusesCount.reduce((acc, status) => acc + status.count, 0)
    },
    influencerLink() {
      return `https://kreditgenie.de/kreditanfrage-wunderlampe?_ic=${this.form.influencer_code}`
    },
    copyInfluencerLink() {
      const el = document.createElement('textarea')
      el.value = this.influencerLink()
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      alert('Link wurde kopiert')
    },
    influencerPropertyLink() {
      return `https://www.kreditgenie.de/wunderlampe-immobilienkredit?_ic=${this.form.influencer_code}`
    },
    copyInfluencerPropertyLink() {
      const el = document.createElement('textarea')
      el.value = this.influencerPropertyLink()
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      alert('Link wurde kopiert')
    },
    update() {
      this.form.post(this.route('influencers.update', this.influencer.id).url(), {
        onSuccess: () => this.form.reset('photo'),
      })
    },
    destroy() {
      if (confirm('Möchten Sie dieses Influencer wirklich löschen?')) {
        this.$inertia.delete(this.route('influencers.destroy', this.influencer.id))
      }
    },
    restore() {
      if (confirm('Möchten Sie dieses Influencer wirklich wiederherstellen?')) {
        this.$inertia.put(this.route('influencers.restore', this.influencer.id))
      }
    },
  },
}
</script>
